import React, { useState } from 'react';

const LocationSelect = ({ value, onChange, disabled }) => {
  const [showCustomInput, setShowCustomInput] = useState(false);
  const [customLocation, setCustomLocation] = useState('');

  // Curated list of South African locations with coordinates
  const locations = [
    // Gauteng - Pretoria/Tshwane
    { name: 'Pretoria', lat: -25.7479, lon: 28.2293 },
    { name: 'Centurion', lat: -25.8601, lon: 28.1889 },
    { name: 'Olievenhoutbosch', lat: -25.8833, lon: 28.2333 },
    { name: 'Mamelodi', lat: -25.7167, lon: 28.3667 },
    { name: 'Atteridgeville', lat: -25.7667, lon: 28.0667 },
    { name: 'Soshanguve', lat: -25.5000, lon: 28.1000 },
    { name: 'Mabopane', lat: -25.5000, lon: 28.1000 },
    { name: 'Ga-Rankuwa', lat: -25.6167, lon: 27.9833 },
    
    // Gauteng - Johannesburg
    { name: 'Johannesburg', lat: -26.2041, lon: 28.0473 },
    { name: 'Sandton', lat: -26.1076, lon: 28.0567 },
    { name: 'Midrand', lat: -25.9953, lon: 28.1289 },
    { name: 'Randburg', lat: -26.0939, lon: 27.9819 },
    { name: 'Roodepoort', lat: -26.1625, lon: 27.8725 },
    { name: 'Soweto', lat: -26.2678, lon: 27.8585 },
    { name: 'Alexandra', lat: -26.1017, lon: 28.0989 },
    { name: 'Fourways', lat: -26.0125, lon: 28.0084 },
    { name: 'Rosebank', lat: -26.1467, lon: 28.0406 },
    { name: 'Diepsloot', lat: -25.9333, lon: 28.0000 },
    { name: 'Orange Farm', lat: -26.5167, lon: 27.8500 },
    { name: 'Ivory Park', lat: -25.9833, lon: 28.3667 },
    
    // Gauteng - East Rand
    { name: 'Benoni', lat: -26.1885, lon: 28.3207 },
    { name: 'Boksburg', lat: -26.2121, lon: 28.2621 },
    { name: 'Germiston', lat: -26.2251, lon: 28.1670 },
    { name: 'Kempton Park', lat: -26.1011, lon: 28.2299 },
    { name: 'Alberton', lat: -26.2674, lon: 28.1216 },
    { name: 'Edenvale', lat: -26.1336, lon: 28.1503 },
    { name: 'Bedfordview', lat: -26.1736, lon: 28.1289 },
    { name: 'Tembisa', lat: -25.9965, lon: 28.2268 },
    { name: 'Katlehong', lat: -26.3333, lon: 28.1500 },
    { name: 'Vosloorus', lat: -26.3500, lon: 28.1833 },
    { name: 'Thokoza', lat: -26.3333, lon: 28.1167 },
    { name: 'Daveyton', lat: -26.1833, lon: 28.3500 },
    { name: 'Springs', lat: -26.2500, lon: 28.4333 },
    { name: 'Brakpan', lat: -26.2333, lon: 28.3667 },
    
    // Gauteng - West Rand & Vaal
    { name: 'Krugersdorp', lat: -26.0853, lon: 27.7676 },
    { name: 'Randfontein', lat: -26.1833, lon: 27.7000 },
    { name: 'Westonaria', lat: -26.3167, lon: 27.6500 },
    { name: 'Carletonville', lat: -26.3667, lon: 27.4000 },
    { name: 'Vanderbijlpark', lat: -26.7167, lon: 27.8333 },
    { name: 'Vereeniging', lat: -26.6667, lon: 27.9333 },
    { name: 'Sasolburg', lat: -26.8167, lon: 27.8167 },
    
    // Western Cape - Cape Town
    { name: 'Cape Town', lat: -33.9249, lon: 18.4241 },
    { name: 'Stellenbosch', lat: -33.9321, lon: 18.8602 },
    { name: 'Paarl', lat: -33.7341, lon: 18.9645 },
    { name: 'Somerset West', lat: -34.0781, lon: 18.8419 },
    { name: 'Bellville', lat: -33.8903, lon: 18.6292 },
    { name: 'Mitchells Plain', lat: -34.0514, lon: 18.6288 },
    { name: 'Khayelitsha', lat: -34.0487, lon: 18.6679 },
    { name: 'Athlone', lat: -33.9606, lon: 18.5028 },
    { name: 'Brackenfell', lat: -33.8667, lon: 18.6972 },
    { name: 'Durbanville', lat: -33.8350, lon: 18.6458 },
    { name: 'Gugulethu', lat: -33.9833, lon: 18.5833 },
    { name: 'Langa', lat: -33.9500, lon: 18.5167 },
    { name: 'Nyanga', lat: -34.0167, lon: 18.5833 },
    { name: 'Philippi', lat: -34.0167, lon: 18.6167 },
    { name: 'Delft', lat: -33.9833, lon: 18.6333 },
    
    // KwaZulu-Natal - Durban
    { name: 'Durban', lat: -29.8587, lon: 31.0218 },
    { name: 'Pietermaritzburg', lat: -29.6007, lon: 30.3794 },
    { name: 'Newcastle', lat: -27.7574, lon: 29.9319 },
    { name: 'Richards Bay', lat: -28.7830, lon: 32.0378 },
    { name: 'Pinetown', lat: -29.8111, lon: 30.8653 },
    { name: 'Umlazi', lat: -29.9667, lon: 30.8833 },
    { name: 'Phoenix', lat: -29.6981, lon: 31.0114 },
    { name: 'KwaMashu', lat: -29.7500, lon: 30.9833 },
    { name: 'Chatsworth', lat: -29.9167, lon: 30.8833 },
    { name: 'Inanda', lat: -29.7000, lon: 30.8833 },
    
    // Eastern Cape
    { name: 'Port Elizabeth', lat: -33.9608, lon: 25.6022 },
    { name: 'East London', lat: -33.0153, lon: 27.9116 },
    { name: 'Mthatha', lat: -31.5889, lon: 28.7842 },
    { name: 'Uitenhage', lat: -33.7578, lon: 25.3971 },
    { name: 'Mdantsane', lat: -32.9833, lon: 27.7333 },
    { name: 'Motherwell', lat: -33.8667, lon: 25.5833 },
    
    // Free State
    { name: 'Bloemfontein', lat: -29.0852, lon: 26.1596 },
    { name: 'Welkom', lat: -27.9770, lon: 26.7350 },
    { name: 'Botshabelo', lat: -29.2333, lon: 26.7167 },
    { name: 'Kroonstad', lat: -27.6500, lon: 27.2333 },
    
    // Limpopo
    { name: 'Polokwane', lat: -23.9045, lon: 29.4689 },
    { name: 'Tzaneen', lat: -23.8333, lon: 30.1667 },
    { name: 'Thohoyandou', lat: -22.9500, lon: 30.4833 },
    { name: 'Lebowakgomo', lat: -24.2000, lon: 29.5000 },
    
    // Mpumalanga
    { name: 'Nelspruit', lat: -25.4753, lon: 30.9700 },
    { name: 'Witbank', lat: -25.8742, lon: 29.2321 },
    { name: 'Middelburg', lat: -25.7750, lon: 29.4650 },
    { name: 'Secunda', lat: -26.5500, lon: 29.1833 },
    
    // North West
    { name: 'Rustenburg', lat: -25.6672, lon: 27.2419 },
    { name: 'Mahikeng', lat: -25.8647, lon: 25.6447 },
    { name: 'Klerksdorp', lat: -26.8667, lon: 26.6667 },
    { name: 'Potchefstroom', lat: -26.7167, lon: 27.1000 },
    
    // Northern Cape
    { name: 'Kimberley', lat: -28.7282, lon: 24.7499 },
    { name: 'Upington', lat: -28.4478, lon: 21.2561 },
  ];

  // Sort alphabetically
  const sortedLocations = [...locations].sort((a, b) => a.name.localeCompare(b.name));

  const handleSelectChange = (e) => {
    const selectedName = e.target.value;
    
    if (selectedName === 'OTHER') {
      setShowCustomInput(true);
      setCustomLocation('');
      onChange('', null, null);
    } else {
      setShowCustomInput(false);
      const location = locations.find(loc => loc.name === selectedName);
      
      if (location) {
        onChange(location.name, location.lat, location.lon);
      } else {
        onChange('', null, null);
      }
    }
  };

  const handleCustomInputChange = (e) => {
    const customValue = e.target.value;
    setCustomLocation(customValue);
    // For custom locations, use approximate South Africa center coordinates
    onChange(customValue, -28.5, 24.5);
  };

  return (
    <div>
      <select
        value={showCustomInput ? 'OTHER' : value}
        onChange={handleSelectChange}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '12px',
          fontSize: '14px',
          borderRadius: '8px',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          background: 'rgba(255, 255, 255, 0.05)',
          color: 'white',
          cursor: 'pointer'
        }}
      >
        <option value="">Select your location</option>
        {sortedLocations.map((location) => (
          <option key={location.name} value={location.name}>
            {location.name}
          </option>
        ))}
        <option value="OTHER">Other (type your location)</option>
      </select>
      
      {showCustomInput && (
        <input
          type="text"
          value={customLocation}
          onChange={handleCustomInputChange}
          placeholder="Enter your city or town"
          disabled={disabled}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '14px',
            borderRadius: '8px',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            background: 'rgba(255, 255, 255, 0.05)',
            color: 'white',
            marginTop: '8px'
          }}
        />
      )}
    </div>
  );
};

export default LocationSelect;
